import React from "react";
import {Button} from "react-bootstrap";

import {useBookmarkContext} from "../../../../hooks/useBookmarkContext";
import "./BookmarkItemButton.scss";

function BookmarkItemButton({ itemId }) {
	const { bookmarkItems, setBookmarkItems, addBookmarkItem } = useBookmarkContext();
	const [_, setBookmarkItem] = React.useState(null);
	const buttonRef = React.useRef(null);

	const bookmarkItem = bookmarkItems?.find(i => i.item?.id === +itemId);

	const applyBookmark = React.useCallback(async () => {
		// in case dupes sneak in, remove all
		const bookmarksExists = bookmarkItems?.filter(i => i.item?.id === +itemId);
		buttonRef.current.classList.add("processing");

		if (bookmarksExists?.length) {
			try {
				await Promise.all(bookmarksExists.map(b => b.remove()));
				setBookmarkItem(undefined);
			}
			catch (e) {
				console.error("Failed to remove bookmark", e);
			}
			finally {
				setBookmarkItems(bookmarkItems?.filter(i => i.item.id !== +itemId));
			}
		}
		else {
			const addedItem = addBookmarkItem(itemId);
			if (addedItem) {
				setBookmarkItem(addedItem);
			}
		}
		buttonRef.current.classList.remove("processing");
	}, [bookmarkItems, itemId]);

	return (
		<Button
			ref={buttonRef}
			variant="link"
			className={["bookmark", bookmarkItem && "is-set"].filter(v=>v).join(" ")}
			onClick={() => applyBookmark()}
		>
			{bookmarkItem ? 'Remove from' : 'Add to'} Bookmarks
		</Button>
	);
}

export default BookmarkItemButton;
